import { Navigate, Outlet } from 'react-router-dom'

import Loading from '@/components/loading'
import { useAuth } from '@/hooks/use-auth'

import { routes } from '../../config'

export function UserRoute() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth()

  if (isAuthLoading) return <Loading />

  if (isAuthenticated) {
    return <Outlet />
  }

  return <Navigate to={routes.Login()} replace />
}
